import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { memo } from "react";
import { CircularLoadingSpinner } from "@/components/CircularLoadingSpinner/CircularLoadingSpinner";
import chestClosedSvg from "@/assets/chest-closed.svg";
import chestLottie from "@/assets/lottie/chest.lottie?url";
import BlownUpIcon from "@/assets/signal2.svg?react";


import type { GridColorScheme } from "@skillscratch/shared-types";

interface SquareContentProps {
  info: SquareInfo;
  tileColor?: {
    background: string;
    text: string;
  };
  colorScheme?: GridColorScheme;
}

export interface HiddenSquareInfo {
  type: "hidden";
}

export interface LoadingSquareInfo {
  type: "loading";
}

export interface TreasureSquareInfo {
  type: "treasure";
  distance: number;
  disabled?: boolean;
}

export interface EmptySquareInfo {
  type: "empty";
  distance: number;
  disabled?: boolean;
}

export interface BlownUpSquareInfo {
  type: "blownUp";
  disabled?: boolean;
}

export type SquareInfo =
  | HiddenSquareInfo
  | LoadingSquareInfo
  | TreasureSquareInfo
  | EmptySquareInfo
  | BlownUpSquareInfo;

export const SquareContent = memo(function SquareContent({
  info,
  tileColor,
  colorScheme,
}: SquareContentProps) {
  console.log('[colorScheme]', colorScheme);

  switch (info.type) {
    case "hidden":
      return null;

    case "treasure":
      return (
        <>
          {info.distance >= 1 && (
            <div
              className="absolute bottom-0 right-0 w-1/4 aspect-square text-[0.5em] flex items-center justify-center"
              style={{
                background: tileColor?.background,
              }}
            >
              <div className="transform translate-y-[10%]">
                {info.distance}
              </div>
            </div>
          )}
          {info.disabled ? (
            <img
              src={chestClosedSvg}
              alt="Treasure"
              className="w-full h-full"
            />
          ) : (
            <DotLottieReact
              src={chestLottie}
              className="w-full h-full"
              autoplay
            />
          )}
        </>
      );

    case "empty":
      return (
        <div className="transform translate-y-[10%]">
          <span>{info.distance}</span>
        </div>
      );

    case "blownUp":
      return (
        <BlownUpIcon className='w-[54%] mx-auto mt-1 block relative z-10' style={{ color: colorScheme?.tileColors[1].background }} />
      );

    case "loading":
      return (
        <div className="max-h-full max-w-full overflow-hidden">
          <CircularLoadingSpinner size="1.5em" fillWidth />
        </div>
      );
  }
});